
<template>
  <div id="adsErrorList" style="height: 400px">
    <el-table :data="tableData" border size="mini" cell-class-name="table-cell"
      row-class-name="table-row" header-cell-class-name="table-header-cell" height="400px">
      <el-table-column type="index" label="序号">
      </el-table-column>
      <el-table-column prop="businessId" label="业务ID" width="80px">
      </el-table-column>
      <el-table-column prop="businessType" label="业务类型" width="120px">
      </el-table-column>
      <el-table-column prop="updateTime" label="操作时间" width="160px">
      </el-table-column>
      <el-table-column prop="operatingType" label="操作类型" width="120px">
      </el-table-column>
      <el-table-column prop="failCount" label="失败次数" width="60px">
      </el-table-column>
      <el-table-column prop="typeText" label="错误类型" width="120px">
      </el-table-column>
      <el-table-column prop="failReason" label="错误原因">
      </el-table-column>
      <el-table-column prop="response" label="返回信息">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { adsModules } from "@r"
export default {
    props: {
      queryData: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data () {
        return {
            tableData: [],
            title: "异常列表"
        }
    },
   created(){
     this.queryErrorList();
     this.title = "异常列表";
    },
    methods: {
        getQueryParams () {
          let params = {
            campaignId: this.$route.query.campaignId,
            businessId: this.$route.query.businessId - 0,
            businessType: this.$route.query.businessType - 0,
          }
          return params;
        },
        queryErrorList () {
          console.log(this.queryData);
          adsModules.getAdvertingErrorLog(this.queryData).then((res) => {
            if(res.result !== 1){
              this.$message({
                type: 'error',
                message: res.message ? res.message : '获取列表失败'
              });
              return;
            }
            this.tableData = res.ldata;
          }).catch((err) => {
            this.$message({
              type: 'error',
              message: err.message ? err.message : '获取列表失败'
            });
            this.tableData = [];
          });
        },
        reload(){
          this.$forceUpdate();
        },
    }
}
</script>

<style lang="scss" scoped>
  .el-page-header {
    padding: 20px 0px;
    border-bottom: solid 1px #e6e6e6;
  }
</style>
